export default {
  en: {    
  	profile: {
      languages: {
        en: 'English',
        nl: 'Dutch',
        fr: 'French'
      },
      changephoto: 'Change photo',  		
      language: 'Language',
      toast: {
        passwordsuccess: "An e-mail with instructions to change your password has been sent.",
        savesuccess: 'Your profile was successfully modified.'
      },
      profile: 'Profile',
      company: 'Company',
      payments: 'Payments',
      notifications: 'Alerts',
      logout: 'Log out',
      cmrinsurance: 'CMR insurance',
      transportlicense: 'Transport license',
      newcmr: 'New CMR document',
      newtransportlicense: 'New transport license document',
      documentstatus: {
        approved: 'Approved',
        new: 'Awaiting approval',
        rejected: 'Rejected',
        expired: 'Expired',
      },
      paymentdetails: {
        'term': 'Payment term',
        '7daysshort': '7 days',
        '10daysshort': '10 working days',
        '30daysshort': '30 days',
        '60daysshort': '60 days',
        '5%short': '5% fee',
        '2%short': '2% fee',
        'nodiscountshort': 'No fee',
        'waitforsenderpaymentshort': 'When the sender pays',
        '10days' : 'Vengo pays you within 10 working days after you finalise a shipment. You agree with a fee of 5% on top of the 5% admin fee.',
        '7days' : 'Vengo pays you within 7 days after receipt of your invoice. You agree with a fee of 5%.',
        '30days' : 'Vengo pays you within 30 days after receipt of your invoice. You agree with a fee of 2%.',
        '60days' : 'Vengo pays you within 60 days after receipt of your invoice. You receive the full amount.',
        'waitforsenderpayment' : 'Vengo pays you within 5 working days after the sender of a shipment you delivered has paid us. You will receive the full amount minus a 5% admin fee.',
        'sb_iban': 'The bank account Vengo will deposit the money to when drivers of your company finalise a shipment.'
      },
      alerts: {
        groups: {
          chat: 'Messages',          
          rating: 'Ratings',
          driver: 'Driver shipments'
        },
        toggles: {
          messages: 'Do you want to be notified when the sender sends the driver a message?',
          ratings: 'Do you want to know what the sender thought of your transport?',
          driver_newshipment: 'Keep me updated about new shipments.',
          driver_shipments: 'Let me know when my bid was accepted by the sender.',
          driver_offeroverview: 'Send me each week, at the end of the week, an overview of my offers and their current status.'
        }
      }         
  	}  	
  },
  nl: {    
  	profile: {
      languages: {
        en: 'Engels',
        nl: 'Nederlands',
        fr: 'Frans'
      },
      changephoto: 'Verander foto',
      language: 'Taal',
      toast: {
        passwordsuccess: "Er werd een e-mail met instructies om uw wachtwoord te wijzigen verzonden",
        savesuccess: 'Je profiel werd succesvol aangepast.'
      },
      profile: 'Profiel',
      company: 'Bedrijf',
      payments: 'Betalingen',
      notifications: 'Meldingen',
      logout: 'Uitloggen',
      cmrinsurance: 'CMR-polis',
      transportlicense: 'Transportvergunning',      
      newcmr: 'Nieuw CMR-document',
      newtransportlicense: 'Nieuw transportvergunningdocument',      
      documentstatus: {
        approved: 'Goedgekeurd',
        new: 'Wachten op goedkeuring',
        rejected: 'Afgewezen',
        expired: 'Vervallen',
      },
      paymentdetails: {
        'term': 'Betalingstermijn',
        '7daysshort': '7 dagen',
        '10daysshort': '10 werkdagen',
        '10daysshort': '10 werkdagen',
        'waitforsenderpaymentshort': 'Als verzender betaalt',
        '60daysshort': '60 dagen',
        '5%short': 'toeslag 5%',
        '2%short': 'toeslag 2%',
        'nodiscountshort': 'Geen toeslag',
        '10days' : 'Vengo betaalt je binnen 10 werkdagen volgend op de dag dat je een zending afrondt. Je gaat akkoord met een toeslag van 5% bovenop de 5% administratiekost.',
        '7days' : 'Vengo betaalt je binnen de 7 dagen volgend op de dag dat we jouw factuur ontvangen. Je gaat akkoord met een toeslag van 5%.',
        '30days' : 'Vengo betaalt je binnen de 30 dagen volgend op de dag dat we jouw factuur ontvangen. Je gaat akkoord met een toeslag van 2%.',
        '60days' : 'Vengo betaalt je binnen de 60 dagen volgend op de dag dat we jouw factuur ontvangen. Je onvangt het volledige bedrag',      
        'waitforsenderpayment' : 'Vengo betaalt je binnen de 5 werkdagen volgend op de dag dat we de betaling ontvangen van de verzender voor het transport dat jij uitvoerde. Je ontvangt het volledige bedrag, minus een administratiekost van 5%.',
        'sb_iban': 'The bank account Vengo will deposit the money to when drivers of your company finalise a shipment.'
      },
      alerts: {
        groups: {
          chat: 'Messages',          
          rating: 'Ratings',
          driver: 'Driver shipments'
        },
        toggles: {
          messages: 'Wil je verwittigd worden wanneer een verzender de chauffeur een bericht stuurt?',
          ratings: 'Wil je weten wat de verzender van het transport vond?',
          driver_newshipment: 'Hou mij op de hoogte over nieuwe zendingen.',
          driver_shipments: 'Laat mij weten wanneer mijn bod werd aanvaard door de verzender.',
          driver_offeroverview: 'Stuur me elke week, aan het einde van de week, een overzicht van mijn boden en hun huidige status.'
        }
      }
  	}  	  	
  },
  fr: {
    profile: {
      languages: {
        en: 'Anglais',
        nl: 'Néerlandais',
        fr: 'Français'
      },
      changephoto: 'changer de photo',
      language: 'Langue',
      toast: {
        passwordsuccess: 'Un courriel avec des instructions pour changer votre mot de passe a été envoyé',
        savesuccess: 'Votre profil a été créé avec succès.'
      },
      profile: 'Profil',
      company: 'Entreprise ',     
      payments: 'Paiements',
      notifications: 'Notifications ',     
      logout: 'Se déconnecter',
      cmrinsurance: 'Assurance CMR ',     
      transportlicense: 'Permis de transport',
      newcmr: 'Nouveau document CMR',
      newtransportlicense: 'Nouveau document Permis de Transport',
      documentstatus: {
        approved: 'Approuvé ',      
        new: 'En attente d\'approbation',
        rejected: 'Rejeté',      
        expired: 'Expiré',     
      },
      paymentdetails: {
        'term': 'Terme de paiement',
        '7daysshort': '7 jours',
        '10daysshort': '10 jours ouvrables',
        '30daysshort': '30 jours',
        '60daysshort': '60 jours',
        '5%short': '5% réduction',
        '2%short': '2% réduction',
        'nodiscountshort': 'Pas de réduction',
        '10days' : 'Vengo vous paie dans les 10 jours ouvrables suivant le jour où vous complétez un envoi. Vous acceptez un supplément de 5% en plus des frais d’administration de 5%.',
        '7days' : 'Vengo vous paie dans les 7 jours après la réception de votre facture.Vous êtes d\'accord avec une réduction de 5%.',      
        '30days' : 'Vengo vous paie dans les 30 jours après la réception de votre facture.Vous êtes d\' accord avec une réduction de 2%.',      
        '60days' : 'Vengo vous paie dans les 60 jours après la réception de votre facture. Vous recevez le montant total.',
        'waitforsenderpayment' : "Vengo vous paie dans les 5 jours ouvrables suivant le jour où nous recevons le paiement de l'expéditeur pour le transport que vous avez effectué. Vous recevez le montant intégral moins des frais d’administration de 5%.",
        'waitforsenderpaymentshort': "Quand l'expéditeur paie",
        'sb_iban': 'Le compte bancaire de Vengo déposera l’argent lorsque les chauffeurs de votre entreprise finaliseront un envoi.'        
      },
      alerts: {
        groups: {
          chat: 'Messages',
          rating: 'Évaluations ',     
          driver: 'Driver shipments'
        },
        toggles: {
          messages: 'Voulez - vous être averti lorsqu\' un expéditeur envoie un message au chauffeur?',
          ratings: 'Voulez - vous savoir ce que l\'expéditeur a trouvé du transport?',
          driver_newshipment: 'Tenez - moi au courant des nouveaux envois.',
          driver_shipments: 'Laissez - moi savoir quand mon offre a été accepté par l\'expéditeur.',
          driver_offeroverview: 'Envoyez - moi un aperçu de mes offres et leur statut actuel chaque semaine à la fin de la semaine.'
        }
      }
    }
  }
}    
